import { useEffect, useState } from "react";
import Header from "../components/Header.jsx";
import Nav from "../components/Nav.jsx";

import Carousel from "../components/carousel.jsx";
import CategoryCard from "../components/category-card.component.jsx";
import categories from "../statics/categories.js";
import Loader from "../components/Loader.jsx";
import api from "../statics/api.js"
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer, toast } from 'react-toastify';
import ProductVertical from "../components/product-vertical.component.jsx";
import ProductHorizontal from "../components/product-horizontal.component.jsx";
import Footer from "../components/footer.component.jsx";
import { set_username } from "../reducers/username.js";
import { set_cart } from "../reducers/cart.js";

import { useDispatch, useSelector } from "react-redux";
import SearchInput from "../components/search-input.component.jsx";
import Overlay from "../components/Overlay.jsx";
import BottomNav from "../components/bottom-nav.component.jsx";
import Cart from "../components/cart.compontent.jsx";
import TawkMessengerReact from '@tawk.to/tawk-messenger-react';
import MobileMenu from "../components/menu.component.jsx";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";


function Shipping() {
    const [isSearching, setIsSearching] = useState(false);
    const [loading, setLoading] = useState(false);

    const handleSearchClick = () => {
        setIsSearching((prev) => !prev);
    };

    useState(() => {
        window.scroll(0, 0)
    }, [])
    return (
        <>
            <Nav></Nav>
            <Header onSearchClick={handleSearchClick}></Header>

            <Helmet>
                <title>PuZzLe Technology Computer Store | Shipping </title>
                <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1"></meta>
                <meta name='description' content="With over 10 years of expertise in computer components, we help you find the best products at the lowest prices." />
                <meta name="keywords" content="PuZzLe Technology, puzzle tech, موقع بازل, موقع البازل, بازل تكنولوجي, محل بازل"></meta>
            </Helmet>
            <h2 className="text-white text-2xl text-center mt-4">Shipping Policies</h2>

            <div class="shipping-policy">
                <div class="policy-content text-white max-w-[800px] mx-8">
                    <ol>
                        <li>
                            <strong>Required Address Details:</strong>
                            <p>The customer must enter complete address details (Governorate, District, Street, or a distinctive landmark).</p>
                            <p>Entering incorrect or incomplete information will result in order cancellation.</p>
                        </li>

                        <li>
                            <strong>Order Processing Time:</strong>
                            <p>Orders are processed within 1 to 3 working days (during official working days).</p>
                            <p>Orders are shipped via Aramex company.</p>
                            <p class="note">Note: Processing may be delayed for reasons beyond the company's control (such as workload during promotional periods).</p>
                        </li>

                        <li>
                            <strong>Shipping Costs:</strong>
                            <p>Cost depends on:</p>
                            <ol type="a">
                                <li>The entered delivery address</li>
                                <li>The shipment dimensions and weight</li>
                            </ol>
                            <p>The customer will be notified of the final cost via the website after order processing and shipping.</p>
                        </li>

                        <li>
                            <strong>Shipping Payment and Order Confirmation:</strong>
                            <p>The customer must transfer the specified shipping amount to confirm the order.</p>
                            <p>For orders exceeding 10,000 EGP, the customer will be required to transfer a deposit (security payment).</p>
                        </li>
                    </ol>

                    <hr />
                    <p class="note"><strong>Note:</strong> Please adhere to these terms to ensure your order is completed without delay or cancellation.</p>
                </div>
            </div>


            <BottomNav currentPage={""}></BottomNav>
            <Footer></Footer>
            {loading ?
                <Loader></Loader>
                : null
            }
            {
                isSearching ?
                    <>
                        <SearchInput></SearchInput>
                        <div onClick={() => setIsSearching(false)}>
                            <Overlay></Overlay>
                        </div>
                    </> : null
            }
            {/* <TawkMessengerReact
                propertyId={process.env.REACT_APP_CHAT_PROPERTY_ID}
                widgetId={process.env.REACT_APP_CHAT_WIDGET_ID} /> */}
            <ToastContainer></ToastContainer>
            <Cart></Cart>
            <MobileMenu></MobileMenu>

        </>
    )
}

export default Shipping;